import { render } from "./BackButtonLink.vue?vue&type=template&id=7cc2acaa"
import script from "./BackButtonLink.vue?vue&type=script&lang=ts"
export * from "./BackButtonLink.vue?vue&type=script&lang=ts"
script.render = render

export default script